module.exports={
	"Scope": "Customer-List",
	"CoreEntity": "Customer",
	"TitleTemplate": "Customers",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Customer Name",
			"Hash": "CustomerListName",
			"PictDashboard": {}
		},
		"Timezone":
		{
			"Name": "Timezone",
			"Hash": "CustomerListTimezone",
			"PictDashboard": {}
		}
	}
}
